export default "__VITE_ASSET__4530c521__"